import {useMemo} from 'react'
import useAggTrades from 'hooks/useAggTrades'
import useRouter from 'hooks/useRouter'
import useSymbolInfo from 'hooks/useSymbolInfo'
import {Card, TradeList} from '@binance/uikit'
import {useDispatch} from 'redux-react-hook'
import {updateOrderPrice} from 'actions'

export default function TradeListView ({i18n}) {
  const router = useRouter()
  const {symbol} = router.query
  const aggTrades = useAggTrades(symbol)
  const {symbolInfo} = useSymbolInfo()
  const {quoteAsset, pricePrecision, quantityPrecision} = symbolInfo
  const dispatch = useDispatch()
  const data = useMemo(
    () =>
      aggTrades.map(el => ({
        id: el.id,
        price: el.price,
        amount: Number(el.quantity),
        time: el.tradeTime,
        type: el.isBuyerMaker ? 'bid' : 'ask'
      })),
    [aggTrades]
  )

  return useMemo(
    () => (
      <Card gridArea="tradelist">
        <TradeList
          data={data}
          decimalPlace={pricePrecision}
          quantityPrecision={quantityPrecision}
          quoteAsset={quoteAsset}
          i18n={i18n}
          onPriceClick={price => {
            dispatch(updateOrderPrice('buy', price, 'limit'))
            dispatch(updateOrderPrice('sell', price, 'limit'))
            dispatch(updateOrderPrice('buy', price, 'stop'))
            dispatch(updateOrderPrice('sell', price, 'stop'))
          }}
        />
      </Card>
    ),
    [data, dispatch, i18n, pricePrecision, quantityPrecision, quoteAsset]
  )
}
